import { DateString } from "../../omnia"
import { PlanField } from "../types"

export interface SelectableSoilAssessment {

    key: number

    sa: Omit<SoilAssessment, "allocations">

    selected: {
        value: boolean
        initial: boolean
    }

}

/**
 * Describes a single soil assessment
 */
export interface SoilAssessment {

    id: number

    date: DateString

    name: string

    allocations: { fieldId: number, croppingId: number }[]

    vess?: number

    wormCount?: number
    wormType?: number

    macroFauna?: number

    infiltrationRate?: number

    pH_0_5?: number
    pH_5_20?: number
    pH_20?: number

}


export function getFieldSoilAssessments(fieldId: number, assessments: SoilAssessment[], planField: PlanField): SelectableSoilAssessment[] {

    const analyses = planField.analyses ?? []
    const excluded = new Set(analyses.filter(a => (a.type === "sa") && (!a.report)).map(a => a.id))

    const result = assessments
        .filter(sa => sa.allocations?.some(a => a.fieldId === fieldId))
        .map(sa => {

            const s = !excluded.has(sa.id)

            return {

                key: sa.id,

                sa,

                selected: {
                    value: s,
                    initial: s
                }

            }

        })

    return result

}
